import React from 'react'
import styled from 'styled-components'
import { Box } from '@material-ui/core'
import LetItGo from './LetItGo'
import Token from './Token'

import LetItGoBack from 'assets/images/letitgo/mask.png'
import LetItGoBackMobile from 'assets/images/letitgo/mobile.png'
import Features from './Features'
import NFT from './NFT'
import CharCard from './CharCard'
import Aboutus from './Aboutus'
import Roadmap from './Roadmap'

interface Props {
    refs: any;
}

const Landing: React.FC<Props> = ({ refs }) => {
    return (
        <StyledContainer>
            <ReadyBack>
                <LetItGo />
                <Token mainRef={refs[0]} />
            </ReadyBack>
            <Features mainRef={refs[1]} />
            <NFT />
            <Roadmap mainRef={refs[2]} />
            <CharCard />
            <Aboutus />
        </StyledContainer>
    )
}

const ReadyBack = styled(Box)`
    position: relative;
    z-index: 2;
    background-repeat: no-repeat;
    background-image: url(${LetItGoBackMobile});
    background-size: 100% auto;
    background-position-y: 52px;
    @media (min-width: 767px) {
        background-repeat: no-repeat;
        background-image: url(${LetItGoBack});
        background-size: auto;
        background-position-y: 0;
    }
`

const StyledContainer = styled(Box)`
    overflow: hidden;
`

export default Landing